import React from 'react';
import SocialIterationsComponent from '../components/SocialIterations';
import { AddonsContextConsumer } from '../../Addons/context/AddonsContext';

function SocialIteration(props) {
  return (
    <AddonsContextConsumer>
      {({ actions: { getCurrencySymbol, getCurrencyIcon } }) =>
      <SocialIterationsComponent
        {...props}
        getCurrencySymbol={getCurrencySymbol}
        getCurrencyIcon={getCurrencyIcon} />}


    </AddonsContextConsumer>);

}

export default SocialIteration;